// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { width } from '@mui/system';

const screenHeight = window.innerHeight;

const getViewWidth = (
  visible: boolean,
  visibleCount: number,
  viewWidth: string,
) => {
  if (!visible) return '0%';
  return Number(visibleCount) === 2 ? '50%' : viewWidth;
};

const styles = (
  viewWidth: string,
  visibility: { las: boolean; pano: boolean },
  visibleCount: number,
  lasVisible: boolean,
  panoVisible: boolean,
) => ({
  containerStyle: {
    width: '100%',
    height: '85vh',
    position: 'relative' as const,
  },

  customLayerListStyle: {
    position: 'absolute' as const,
    top: 200,
    left: 14,
    zIndex: 99,
    background: 'white',
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    maxHeight: screenHeight >= 945 ? '650px' : '430px',
    overflowY: 'auto' as const,
    width: '320px',
    fontFamily: 'Arial, sans-serif',
    fontSize: '14px',
    display: 'none',
  },

  activecad: {
    marginTop: '8px',
    marginLeft: '16px',
  },

  layerTitle: {
    margin: '0 0 10px 0',
    fontWeight: 'bold',
  },

  checkboxStyle: {
    marginRight: '8px',
  },

  labelText: {
    flexGrow: 1,
  },

  layerLabelStyle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '6px',
    cursor: 'pointer',
  },

  colorBoxStyle: {
    display: 'inline-block',
    width: '16px',
    height: '16px',
    marginLeft: '6px',
    border: '1px solid #666',
  },

  siteSearchContainer: {
    position: 'absolute' as const,
    top: 200,
    left: 15,
    zIndex: 99,
  },

  orderSearchContainer: {
    position: 'absolute' as const,
    top: 240,
    left: 15,
    zIndex: 99,
  },

  inputStyle: {
    padding: '5px',
    fontSize: '15px',
  },

  buttonStyle: {
    marginLeft: '5px',
    padding: '5px',
  },

  viewDivStyle: {
    width: '100%',
    height: '100%',
  },

  returncolor: {
    color: '#ffffff',
  },

  orthomossaicStrater: {
    marginTop: '10px',
  },

  pointcloudStarter: {
    marginTop: '10px',
  },

  milStrater: {
    marginTop: '10px',
  },

  filStarter: {
    marginTop: '10px',
  },

  cadFilesContainer: {
    marginTop: '10px',
  },

  cadFileLength: {
    fontSize: '13px',
  },

  siteContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    padding: '6px 8px',
    background: '#f5f5f5',
  },

  cadFileHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  cadFileHeaderLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  siteSpan: {
    fontSize: '13px',
  },

  togglecheck: {
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: '#0079c1',
  },

  map: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    top: 0,
    bottom: 0,
    width: '100%',
    flex: 1,
  },

  esriView: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row' as const,
    justifyContent: 'space-between',
    position: 'relative' as const,
  },

  selectView: {
    position: 'absolute',
    bottom: '20px',
    right: '0%',
    transform: 'translateX(-50%)',
    width: 'auto',
    padding: '6px 3px',
    background: '#FFFFFFCC',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    zIndex: 10,
    opacity: '95%',
    color: '#788898',
  },

  lasView: {
    width: getViewWidth(lasVisible, visibleCount, viewWidth),
    height: '100%',
    position: 'relative' as const,
    visibility: visibility.las ? ('visible' as const) : ('hidden' as const),
    opacity: visibility.las ? 1 : 0,
    transition: 'opacity 0.3s ease',
    border: '2px solid white',
  },

  panoView: {
    width: getViewWidth(panoVisible, visibleCount, viewWidth),
    height: '100%',
    visibility: visibility.pano ? 'visible' : 'hidden',
    opacity: visibility.pano ? 1 : 0,
    transition: 'opacity 0.3s ease',
    border: '2px solid white',
    position: 'relative',
    overflow: 'hidden',
  },
  eyeVisible: {
    cursor: 'pointer',
    width: '20px',
    height: '20px',
    stroke: 'black',
  },
  eyeHidden: {
    cursor: 'pointer',
    width: '20px',
    height: '20px',
    stroke: 'gray',
  },
  toggleButton: {
    cursor: 'pointer',
    border: 'none',
    padding: '5px 10px',
    borderRadius: '6px',
    background: 'transparent',
    color: '#021E40',
  },
  toggleButtonOff: {
    cursor: 'pointer',
    border: 'none',
    padding: '5px 10px',
    borderRadius: '6px',
    background: 'transparent',
    color: '#021E40',
  },
  noPanoTooltip: {
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    marginBottom: '6px',
    padding: '6px 10px',
    background: '#FFFFFF',
    fontSize: '12px',
    color: '#021E40',
    whiteSpace: 'nowrap',
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    zIndex: 20,
  },
  panoViewDiv: {
    width: '100%',
    Height: '100%',
  },
  popupDiv: {
    display: 'none',
    width: '30%',
    height: '30%',
  },
  popupContainer: (position: {
    left: number;
    right: number;
    top: number;
    transform?: string;
  }) => ({
    position: 'absolute',
    background: '#ffffff',
    borderRadius: '10px',
    padding: '0',
    width: '420px',
    minWidth: '420px',
    maxWidth: '420px',
    boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
    border: '1px solid #cfcfcf',
    fontFamily: 'Inter, sans-serif',
    zIndex: 10000,
    overflowX: 'hidden',
    overflowY: 'hidden',
    pointerEvents: 'auto',
    left: position.left,
    top: position.top,
    right: position.right,
    transform: position.transform,
  }),
  layerNameText: {
    display: 'block',
    fontWeight: 600,
    fontSize: '14px',
    color: '#000',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px',
    padding: '4px 8px',
  },
  popupHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '3px 14px',
    borderBottom: '1px solid #e6e6e6',
    fontWeight: 600,
    fontSize: '14px',
    background: '#fafafa',
    cursor: 'move',
  },

  popupLayerInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  layerColorBox: (color: string) => ({
    width: '14px',
    height: '14px',
    borderRadius: '3px',
    backgroundColor: color,
    border: '1px solid #666',
  }),

  popupControls: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '1px',
    fontSize: '9px',
    fontWeight: '300',
    color: '#444',
  },

  popupClose: {
    cursor: 'pointer',
    fontSize: '18px',
    marginLeft: '6px',
    opacity: 0.75,
  },

  popupCloseHover: {
    opacity: 1,
  },

  popupTable: {
    width: '100%',
    borderColor: '#222',
    fontSize: '10px',
  },
  popupContentWrapper: {
    width: '100%',
    maxHeight: '180px',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  popupTableRow: (index: number) => ({
    background: index % 2 === 0 ? '#ffffff' : '#f7f7f7',
  }),

  popupTableCellKey: {
    padding: '6px 8px',
    fontWeight: 700,
    width: '50%',
    color: '#444',
  },

  popupTableCellValue: {
    padding: '6px 8px',
    textAlign: 'left',
    color: '#222',
    width: '50%',
    fontWeight: 400,
    border: '#222',
  },
  prev_btn: {
    background: 'transparent',
    color: '#008B8B',
    border: 'none',
    fontSize: '15px',
  },
  next_btn: {
    background: 'transparent',
    color: '#008B8B',
    border: 'none',
    fontSize: '15px',
  },
  clickaway: {
    position: 'fixed',
    width: 300,
    backgroundColor: 'white',
    borderRadius: 2,
    boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
    zIndex: 1400,
    p: 2.5,
    border: '1px solid #e0e0e0',
    transform: 'translateY(-50%)',
  },
  panoControlsCss: `
  #panoDiv .pnlm-compass,
  #panoDiv .pnlm-controls,
  #panoDiv .pnlm-control {
    display: none !important;
  }
 
  #panoDiv .pnlm-hotspot {
    background-image: none !important;
     transform: none !important;
     
  }
  .pano-icon-leftScene {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNTMiIHZpZXdCb3g9IjAgMCA1MSA1MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZGlfOTY0XzY2MSkiPgo8cGF0aCBkPSJNNDUuNjgyNiA0Mi4yMDEyTDguOTk3MDcgMTkuNTM5M0w0MS4xODMxIDIuMjAxMDEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iNSIvPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2RpXzk2NF82NjEiIHg9IjAiIHk9IjAiIHdpZHRoPSI1MC45OTYxIiBoZWlnaHQ9IjUyLjMyODEiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiIHJlc3VsdD0iaGFyZEFscGhhIi8+CjxmZU9mZnNldCBkeT0iNCIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyIi8+CjxmZUNvbXBvc2l0ZSBpbjI9ImhhcmRBbHBoYSIgb3BlcmF0b3I9Im91dCIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4yNSAwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93Xzk2NF82NjEiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3dfOTY0XzY2MSIgcmVzdWx0PSJzaGFwZSIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIgcmVzdWx0PSJoYXJkQWxwaGEiLz4KPGZlT2Zmc2V0Lz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMC41Ii8+CjxmZUNvbXBvc2l0ZSBpbjI9ImhhcmRBbHBoYSIgb3BlcmF0b3I9ImFyaXRobWV0aWMiIGsyPSItMSIgazM9IjEiLz4KPGZlQ29sb3JNYXRyaXggdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAuMjUgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0ic2hhcGUiIHJlc3VsdD0iZWZmZWN0Ml9pbm5lclNoYWRvd185NjRfNjYxIi8+CjwvZmlsdGVyPgo8L2RlZnM+Cjwvc3ZnPgo=) !important;
    background-size: contain !important;
    width: 80px !important;
    height: 80px !important;
 
  }
 
  .pano-icon-rightScene {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDkiIGhlaWdodD0iNTUiIHZpZXdCb3g9IjAgMCA0OSA1NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZGlfOTY0XzY2MikiPgo8cGF0aCBkPSJNNS40NDgyNyA0NC41NTlMMzkuOTQ3OCAyMC4wNTkxTDUuNDQ4MjcgMi4yMjA4MiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSI1Ii8+CjwvZz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZGlfOTY0XzY2MiIgeD0iMCIgeT0iMCIgd2lkdGg9IjQ4Ljc0MDIiIGhlaWdodD0iNTQuNTk3NyIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIgcmVzdWx0PSJoYXJkQWxwaGEiLz4KPGZlT2Zmc2V0IGR5PSI0Ii8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjIiLz4KPGZlQ29tcG9zaXRlIGluMj0iaGFyZEFscGhhIiBvcGVyYXRvcj0ib3V0Ii8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjI1IDAiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJlZmZlY3QxX2Ryb3BTaGFkb3dfOTY0XzY2MiIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvd185NjRfNjYyIiByZXN1bHQ9InNoYXBlIi8+CjxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIiByZXN1bHQ9ImhhcmRBbHBoYSIvPgo8ZmVPZmZzZXQvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIwLjUiLz4KPGZlQ29tcG9zaXRlIGluMj0iaGFyZEFscGhhIiBvcGVyYXRvcj0iYXJpdGhtZXRpYyIgazI9Ii0xIiBrMz0iMSIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4yNSAwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJzaGFwZSIgcmVzdWx0PSJlZmZlY3QyX2lubmVyU2hhZG93Xzk2NF82NjIiLz4KPC9maWx0ZXI+CjwvZGVmcz4KPC9zdmc+Cg==) !important;
    background-size: contain !important;
    width: 80px !important;
    height: 85px !important;
  }
 
  .pano-icon-nextScene {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTMiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCA5MyAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZGlfOTY0XzY1OSkiPgo8cGF0aCBkPSJNNS4xMjEwOSAyMy4yOTNMNDUuOTc2NiAyLjc5Mjk3TDg3LjQ3NjYgMjMuMjkzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjUiLz4KPC9nPgo8ZGVmcz4KPGZpbHRlciBpZD0iZmlsdGVyMF9kaV85NjRfNjU5IiB4PSIwIiB5PSIwIiB3aWR0aD0iOTIuNTg0IiBoZWlnaHQ9IjMzLjUzNDIiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiIHJlc3VsdD0iaGFyZEFscGhhIi8+CjxmZU9mZnNldCBkeT0iNCIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyIi8+CjxmZUNvbXBvc2l0ZSBpbjI9ImhhcmRBbHBoYSIgb3BlcmF0b3I9Im91dCIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4yNSAwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93Xzk2NF82NTkiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3dfOTY0XzY1OSIgcmVzdWx0PSJzaGFwZSIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIgcmVzdWx0PSJoYXJkQWxwaGEiLz4KPGZlT2Zmc2V0Lz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMC41Ii8+CjxmZUNvbXBvc2l0ZSBpbjI9ImhhcmRBbHBoYSIgb3BlcmF0b3I9ImFyaXRobWV0aWMiIGsyPSItMSIgazM9IjEiLz4KPGZlQ29sb3JNYXRyaXggdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAuMjUgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0ic2hhcGUiIHJlc3VsdD0iZWZmZWN0Ml9pbm5lclNoYWRvd185NjRfNjU5Ii8+CjwvZmlsdGVyPgo8L2RlZnM+Cjwvc3ZnPgo=) !important;
    background-size: contain !important;
    width: 125px !important;
    height: 45px !important;
   
  }
 
  .pano-icon-previousScene {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTIiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCA5MiAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZGlfOTY0XzY2MCkiPgo8cGF0aCBkPSJNNS4zMTA1NSAyLjE2NDA2TDQ0LjMxMDUgMjYuMTY0MUw4NS44MTA1IDIuMTY0MDYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iNSIvPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2RpXzk2NF82NjAiIHg9IjAiIHk9IjAiIHdpZHRoPSI5MS4wNjI1IiBoZWlnaHQ9IjM3LjA3NTIiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiIHJlc3VsdD0iaGFyZEFscGhhIi8+CjxmZU9mZnNldCBkeT0iNCIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyIi8+CjxmZUNvbXBvc2l0ZSBpbjI9ImhhcmRBbHBoYSIgb3BlcmF0b3I9Im91dCIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4yNSAwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93Xzk2NF82NjAiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3dfOTY0XzY2MCIgcmVzdWx0PSJzaGFwZSIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIgcmVzdWx0PSJoYXJkQWxwaGEiLz4KPGZlT2Zmc2V0Lz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMC41Ii8+CjxmZUNvbXBvc2l0ZSBpbjI9ImhhcmRBbHBoYSIgb3BlcmF0b3I9ImFyaXRobWV0aWMiIGsyPSItMSIgazM9IjEiLz4KPGZlQ29sb3JNYXRyaXggdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAuMjUgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0ic2hhcGUiIHJlc3VsdD0iZWZmZWN0Ml9pbm5lclNoYWRvd185NjRfNjYwIi8+CjwvZmlsdGVyPgo8L2RlZnM+Cjwvc3ZnPgo=) !important;
    background-size: contain !important;
    width: 145px !important;
    height: 60px !important;
}

/* Hide default Pannellum error UI */
#panoDiv .pnlm-error-msg,
#panoDiv .pnlm-info-box {
  display: none !important;
}


.pano-toast {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  gap: 12px;
  background: #ffffff;
  padding: 14px 16px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.18);
  z-index: 10000;
  min-width: 320px;
  max-width: 420px;
  font-family: "Work Sans", sans-serif;
}

.pano-toast-icon {
  width: 28px;
  height: 28px;
  background: #ff3b30;
  color: #fff;
  border-radius: 50%;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pano-toast-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e1e1e;
  margin-bottom: 4px;
}

.pano-toast-subtitle {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

.pano-toast-subtitle a {
  color: #0078ff;
  text-decoration: none;
}

.pano-toast-close {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  color: #999;
}

 #panoDiv .pnlm-error-msg.pnlm-info-box {
    background: #fff !important;
    color: #1e1e1e !important;
    padding: 20px !important;
    border-radius: 14px !important;
    font-size: 12px !important;
    font-family: "Work Sans", sans-serif !important;
    text-align: text-align: left;
    box-shadow: 0px 4px 10px rgba(0,0,0,0.3) !important;
    width: 270px !important;
    height: 5px;
    position: relative !important;
    left: 45%;
  }
 
#panoDiv .pnlm-error-msg.pnlm-info-box::before {
  content: "";
  display: block;
  width: 40px;
  height: 40px;
  position: relative;
  top: 20px;
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIyMCIgY3k9IjIwIiByPSIyMCIgZmlsbD0iI0ZGNEQ0RiIvPgogIDxyZWN0IHg9IjE4IiB5PSI5IiB3aWR0aD0iNCIgaGVpZ2h0PSIxNiIgcng9IjIiIGZpbGw9IndoaXRlIi8+CiAgPGNpcmNsZSBjeD0iMjAiIGN5PSIzMCIgcj0iMiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+');
}
 
#panoDiv .pnlm-error-msg.pnlm-info-box * {
  background: transparent !important;
  border: none !important;
  color: inherit !important;
  width: 215px;
  top: 0px;
  position: relative;
}

 #panoDiv .pnlm-error-msg.pnlm-info-box {
  background: #fff !important;
  color: #1e1e1e !important;
  padding: 20px !important;
  border-radius: 14px !important;
  font-size: 12px !important;
  font-family: "Work Sans", sans-serif !important;
  text-align: text-align: left;
  box-shadow: 0px 4px 10px rgba(0,0,0,0.3) !important;
  width: 270px !important;
      height: 5px;
  position: relative !important;
  left: 45%;
}
 
 
#panoDiv .pnlm-error-msg.pnlm-info-box::before {
  content: "";
  display: block;
  width: 40px;
  height: 40px;
  position: relative;
  top: 20px;
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIyMCIgY3k9IjIwIiByPSIyMCIgZmlsbD0iI0ZGNEQ0RiIvPgogIDxyZWN0IHg9IjE4IiB5PSI5IiB3aWR0aD0iNCIgaGVpZ2h0PSIxNiIgcng9IjIiIGZpbGw9IndoaXRlIi8+CiAgPGNpcmNsZSBjeD0iMjAiIGN5PSIzMCIgcj0iMiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+');
  }
 
#panoDiv .pnlm-error-msg.pnlm-info-box * {
  background: transparent !important;
  border: none !important;
  color: inherit !important;
  width: 215px;
  top: 0px;
  position: relative;
}

//pano loading icon
#panoDiv .pnlm-lmsg {
  display: none !important;
}
#panoDiv .pnlm-container.pnlm-loading .pnlm-load-box {
  display: flex;
}
#panoDiv .pnlm-load-box {
    display: none;
    position: absolute !important;
    width: 100vw;
    height: 100vh;
    top: 63%;
    left: 66%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    align-items: center;
    justify-content: center;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjIiIGhlaWdodD0iNTgiIHZpZXdCb3g9IjAgMCA2MiA1OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMjMzMTMgNTMuMDI4SDEwLjA1NzFWNTQuNUgyLjUyMTEzVjQzLjk0SDQuMjMzMTNWNTMuMDI4Wk0xNS4xNDM4IDQ2LjM0QzE1LjkyMjQgNDYuMzQgMTYuNjEwNCA0Ni41MDUzIDE3LjIwNzggNDYuODM2QzE3LjgwNTEgNDcuMTY2NyAxOC4yNjkxIDQ3LjY0NjcgMTguNTk5OCA0OC4yNzZDMTguOTQxMSA0OC44OTQ3IDE5LjExMTggNDkuNjM2IDE5LjExMTggNTAuNUMxOS4xMTE4IDUxLjM2NCAxOC45NDExIDUyLjExMDcgMTguNTk5OCA1Mi43NEMxOC4yNjkxIDUzLjM1ODcgMTcuODA1MSA1My44MzMzIDE3LjIwNzggNTQuMTY0QzE2LjYxMDQgNTQuNDk0NyAxNS45MjI0IDU0LjY2IDE1LjE0MzggNTQuNjZDMTQuMzY1MSA1NC42NiAxMy42NzcxIDU0LjQ5NDcgMTMuMDc5OCA1NC4xNjRDMTIuNDgyNCA1My44MzMzIDEyLjAxMzEgNTMuMzU4NyAxMS42NzE4IDUyLjc0QzExLjMzMDQgNTIuMTEwNyAxMS4xNTk4IDUxLjM2NCAxMS4xNTk4IDUwLjVDMTEuMTU5OCA0OS42MzYgMTEuMzMwNCA0OC44OTQ3IDExLjY3MTggNDguMjc2QzEyLjAxMzEgNDcuNjQ2NyAxMi40ODI0IDQ3LjE2NjcgMTMuMDc5OCA0Ni44MzZDMTMuNjc3MSA0Ni41MDUzIDE0LjM2NTEgNDYuMzQgMTUuMTQzOCA0Ni4zNFpNMTUuMTQzOCA0Ny42ODRDMTQuNjYzOCA0Ny42ODQgMTQuMjUzMSA0Ny43OTYgMTMuOTExOCA0OC4wMkMxMy41ODExIDQ4LjIzMzMgMTMuMzI1MSA0OC41NDggMTMuMTQzOCA0OC45NjRDMTIuOTYyNCA0OS4zOCAxMi44NzE4IDQ5Ljg5MiAxMi44NzE4IDUwLjVDMTIuODcxOCA1MS4wOTczIDEyLjk2MjQgNTEuNjA5MyAxMy4xNDM4IDUyLjAzNkMxMy4zMjUxIDUyLjQ1MiAxMy41ODExIDUyLjc3MiAxMy45MTE4IDUyLjk5NkMxNC4yNTMxIDUzLjIwOTMgMTQuNjYzOCA1My4zMTYgMTUuMTQzOCA1My4zMTZDMTUuNjIzOCA1My4zMTYgMTYuMDI5MSA1My4yMDkzIDE2LjM1OTggNTIuOTk2QzE2LjY5MDQgNTIuNzcyIDE2Ljk0NjQgNTIuNDUyIDE3LjEyNzggNTIuMDM2QzE3LjMwOTEgNTEuNjA5MyAxNy4zOTk4IDUxLjA5NzMgMTcuMzk5OCA1MC41QzE3LjM5OTggNDkuODkyIDE3LjMwOTEgNDkuMzggMTcuMTI3OCA0OC45NjRDMTYuOTQ2NCA0OC41NDggMTYuNjkwNCA0OC4yMzMzIDE2LjM1OTggNDguMDJDMTYuMDI5MSA0Ny43OTYgMTUuNjIzOCA0Ny42ODQgMTUuMTQzOCA0Ny42ODRaTTI1Ljg3MzkgNDkuMzY0QzI1Ljg3MzkgNDguODMwNyAyNS43MjQ1IDQ4LjQyIDI1LjQyNTkgNDguMTMyQzI1LjEzNzkgNDcuODMzMyAyNC43Mzc5IDQ3LjY4NCAyNC4yMjU5IDQ3LjY4NEMyMy43NDU5IDQ3LjY4NCAyMy4zMzUyIDQ3Ljc5NiAyMi45OTM5IDQ4LjAyQzIyLjY1MjUgNDguMjQ0IDIyLjQwMTkgNDguNjA2NyAyMi4yNDE5IDQ5LjEwOEwyMC44MDE5IDQ4LjVDMjEuMDA0NSA0Ny44NDkzIDIxLjM5OTIgNDcuMzI2NyAyMS45ODU5IDQ2LjkzMkMyMi41ODMyIDQ2LjUzNzMgMjMuMzUxMiA0Ni4zNCAyNC4yODk5IDQ2LjM0QzI0LjkyOTkgNDYuMzQgMjUuNDk1MiA0Ni40NDY3IDI1Ljk4NTkgNDYuNjZDMjYuNDc2NSA0Ni44NjI3IDI2Ljg2MDUgNDcuMTcyIDI3LjEzNzkgNDcuNTg4QzI3LjQyNTkgNDguMDA0IDI3LjU2OTkgNDguNTM3MyAyNy41Njk5IDQ5LjE4OFY1Mi43NTZDMjcuNTY5OSA1My4xNTA3IDI3Ljc2NzIgNTMuMzQ4IDI4LjE2MTkgNTMuMzQ4QzI4LjM1MzkgNTMuMzQ4IDI4LjU0MDUgNTMuMzIxMyAyOC43MjE5IDUzLjI2OEwyOC42MjU5IDU0LjQ1MkMyOC4zODA1IDU0LjU2OTMgMjguMDcxMiA1NC42MjggMjcuNjk3OSA1NC42MjhDMjcuMzU2NSA1NC42MjggMjcuMDQ3MiA1NC41NjkzIDI2Ljc2OTkgNTQuNDUyQzI2LjUwMzIgNTQuMzI0IDI2LjI4OTkgNTQuMTM3MyAyNi4xMjk5IDUzLjg5MkMyNS45ODA1IDUzLjYzNiAyNS45MDU5IDUzLjMyMTMgMjUuOTA1OSA1Mi45NDhWNTIuODM2TDI2LjI1NzkgNTIuODJDMjYuMTYxOSA1My4yMzYgMjUuOTY0NSA1My41ODI3IDI1LjY2NTkgNTMuODZDMjUuMzY3MiA1NC4xMjY3IDI1LjAyMDUgNTQuMzI5MyAyNC42MjU5IDU0LjQ2OEMyNC4yMzEyIDU0LjU5NiAyMy44MzEyIDU0LjY2IDIzLjQyNTkgNTQuNjZDMjIuOTI0NSA1NC42NiAyMi40NzEyIDU0LjU4IDIyLjA2NTkgNTQuNDJDMjEuNjcxMiA1NC4yNiAyMS4zNTY1IDU0LjAyIDIxLjEyMTkgNTMuN0MyMC44OTc5IDUzLjM2OTMgMjAuNzg1OSA1Mi45NjQgMjAuNzg1OSA1Mi40ODRDMjAuNzg1OSA1MS44ODY3IDIwLjk3NzkgNTEuMzk2IDIxLjM2MTkgNTEuMDEyQzIxLjc1NjUgNTAuNjI4IDIyLjMxMTIgNTAuMzY2NyAyMy4wMjU5IDUwLjIyOEwyNi4xMjk5IDQ5LjYyTDI2LjExMzkgNTAuODJMMjMuODU3OSA1MS4yODRDMjMuNDA5OSA1MS4zNjkzIDIzLjA3MzkgNTEuNDkyIDIyLjg0OTkgNTEuNjUyQzIyLjYyNTkgNTEuODEyIDIyLjUxMzkgNTIuMDQ2NyAyMi41MTM5IDUyLjM1NkMyMi41MTM5IDUyLjY1NDcgMjIuNjI1OSA1Mi44OTQ3IDIyLjg0OTkgNTMuMDc2QzIzLjA4NDUgNTMuMjQ2NyAyMy4zOTM5IDUzLjMzMiAyMy43Nzc5IDUzLjMzMkMyNC4wNDQ1IDUzLjMzMiAyNC4zMDA1IDUzLjMgMjQuNTQ1OSA1My4yMzZDMjQuODAxOSA1My4xNzIgMjUuMDMxMiA1My4wNzA3IDI1LjIzMzkgNTIuOTMyQzI1LjQzNjUgNTIuNzgyNyAyNS41OTEyIDUyLjU5NiAyNS42OTc5IDUyLjM3MkMyNS44MTUyIDUyLjEzNzMgMjUuODczOSA1MS44NiAyNS44NzM5IDUxLjU0VjQ5LjM2NFpNMzMuNDMxMyA1NC42NkMzMi43Njk5IDU0LjY2IDMyLjE2NzMgNTQuNDk0NyAzMS42MjMzIDU0LjE2NEMzMS4wODk5IDUzLjgzMzMgMzAuNjY4NiA1My4zNTg3IDMwLjM1OTMgNTIuNzRDMzAuMDQ5OSA1Mi4xMjEzIDI5Ljg5NTMgNTEuMzggMjkuODk1MyA1MC41MTZDMjkuODk1MyA0OS42MiAzMC4wNjA2IDQ4Ljg2MjcgMzAuMzkxMyA0OC4yNDRDMzAuNzIxOSA0Ny42MjUzIDMxLjE2NDYgNDcuMTU2IDMxLjcxOTMgNDYuODM2QzMyLjI3MzkgNDYuNTA1MyAzMi44ODE5IDQ2LjM0IDMzLjU0MzMgNDYuMzRDMzQuMjI1OSA0Ni4zNCAzNC44MDE5IDQ2LjUyNjcgMzUuMjcxMyA0Ni45QzM1Ljc0MDYgNDcuMjczMyAzNi4wNTUzIDQ3Ljc1ODcgMzYuMjE1MyA0OC4zNTZMMzYuMDIzMyA0OC41MzJWNDIuOUgzNy43MzUzVjU0LjVIMzYuMjE1M0wzNi4wODczIDUyLjMyNEwzNi4zMTEzIDUyLjM0QzM2LjIzNjYgNTIuODIgMzYuMDYwNiA1My4yMzYgMzUuNzgzMyA1My41ODhDMzUuNTA1OSA1My45MjkzIDM1LjE1OTMgNTQuMTk2IDM0Ljc0MzMgNTQuMzg4QzM0LjMzNzkgNTQuNTY5MyAzMy45MDA2IDU0LjY2IDMzLjQzMTMgNTQuNjZaTTMzLjc5OTMgNTMuMjg0QzM0LjI1NzkgNTMuMjg0IDM0LjY1MjYgNTMuMTY2NyAzNC45ODMzIDUyLjkzMkMzNS4zMTM5IDUyLjY5NzMgMzUuNTY5OSA1Mi4zNjY3IDM1Ljc1MTMgNTEuOTRDMzUuOTMyNiA1MS41MTMzIDM2LjAyMzMgNTEuMDAxMyAzNi4wMjMzIDUwLjQwNEMzNi4wMjMzIDQ5Ljg0OTMgMzUuOTMyNiA0OS4zNzQ3IDM1Ljc1MTMgNDguOThDMzUuNTY5OSA0OC41NzQ3IDM1LjMxMzkgNDguMjY1MyAzNC45ODMzIDQ4LjA1MkMzNC42NjMzIDQ3LjgzODcgMzQuMjg5OSA0Ny43MzIgMzMuODYzMyA0Ny43MzJDMzMuMTQ4NiA0Ny43MzIgMzIuNTkzOSA0Ny45NzczIDMyLjE5OTMgNDguNDY4QzMxLjgwNDYgNDguOTU4NyAzMS42MDczIDQ5LjYzNiAzMS42MDczIDUwLjVDMzEuNjA3MyA1MS4zNjQgMzEuNzk5MyA1Mi4wNDY3IDMyLjE4MzMgNTIuNTQ4QzMyLjU2NzMgNTMuMDM4NyAzMy4xMDU5IDUzLjI4NCAzMy43OTkzIDUzLjI4NFpNNDEuMjU0NSA0NS4xNTZDNDAuODgxMiA0NS4xNTYgNDAuNTkzMiA0NS4wNjUzIDQwLjM5MDUgNDQuODg0QzQwLjE5ODUgNDQuNjkyIDQwLjEwMjUgNDQuNDI1MyA0MC4xMDI1IDQ0LjA4NEM0MC4xMDI1IDQzLjc0MjcgNDAuMTk4NSA0My40ODEzIDQwLjM5MDUgNDMuM0M0MC41OTMyIDQzLjExODcgNDAuODgxMiA0My4wMjggNDEuMjU0NSA0My4wMjhDNDEuNjE3MiA0My4wMjggNDEuODk0NSA0My4xMTg3IDQyLjA4NjUgNDMuM0M0Mi4yODkyIDQzLjQ4MTMgNDIuMzkwNSA0My43NDI3IDQyLjM5MDUgNDQuMDg0QzQyLjM5MDUgNDQuNDI1MyA0Mi4yODkyIDQ0LjY5MiA0Mi4wODY1IDQ0Ljg4NEM0MS44OTQ1IDQ1LjA2NTMgNDEuNjE3MiA0NS4xNTYgNDEuMjU0NSA0NS4xNTZaTTQyLjEwMjUgNDYuNVY1NC41SDQwLjM5MDVWNDYuNUg0Mi4xMDI1Wk00NC43ODExIDU0LjVWNDYuNUg0Ni4zMDExTDQ2LjQxMzEgNDguNThMNDYuMTg5MSA0OC4zNTZDNDYuMzM4NSA0Ny44OTczIDQ2LjU1MTggNDcuNTE4NyA0Ni44MjkxIDQ3LjIyQzQ3LjExNzEgNDYuOTEwNyA0Ny40NTMxIDQ2LjY4NjcgNDcuODM3MSA0Ni41NDhDNDguMjMxOCA0Ni40MDkzIDQ4LjY0NzggNDYuMzQgNDkuMDg1MSA0Ni4zNEM0OS42NTA1IDQ2LjM0IDUwLjE1NzEgNDYuNDUyIDUwLjYwNTEgNDYuNjc2QzUxLjA2MzggNDYuODg5MyA1MS40MjY1IDQ3LjIxNDcgNTEuNjkzMSA0Ny42NTJDNTEuOTU5OCA0OC4wODkzIDUyLjA5MzEgNDguNjQ0IDUyLjA5MzEgNDkuMzE2VjU0LjVINTAuMzgxMVY0OS44NDRDNTAuMzgxMSA0OS4wNTQ3IDUwLjIxNTggNDguNTEwNyA0OS44ODUxIDQ4LjIxMkM0OS41NjUxIDQ3LjkwMjcgNDkuMTU5OCA0Ny43NDggNDguNjY5MSA0Ny43NDhDNDguMzE3MSA0Ny43NDggNDcuOTc1OCA0Ny44MzMzIDQ3LjY0NTEgNDguMDA0QzQ3LjMxNDUgNDguMTY0IDQ3LjAzNzEgNDguNDI1MyA0Ni44MTMxIDQ4Ljc4OEM0Ni41OTk4IDQ5LjE1MDcgNDYuNDkzMSA0OS42MzYgNDYuNDkzMSA1MC4yNDRWNTQuNUg0NC43ODExWk02MS43Mjc0IDQ0LjgyTDYxLjk5OTQgNDYuMTY0QzYxLjk2NzQgNDYuMTY0IDYxLjkzNTQgNDYuMTY0IDYxLjkwMzQgNDYuMTY0QzYxLjg3MTQgNDYuMTUzMyA2MS44Mzk0IDQ2LjE0OCA2MS44MDc0IDQ2LjE0OEM2MS4yOTU0IDQ2LjE0OCA2MC45MDYgNDYuMjYgNjAuNjM5NCA0Ni40ODRDNjAuMzcyNyA0Ni42OTczIDYwLjIzOTQgNDcuMDEyIDYwLjIzOTQgNDcuNDI4TDU5LjQwNzQgNDcuMDQ0QzU5LjQwNzQgNDYuNjE3MyA1OS40OTggNDYuMjM4NyA1OS42Nzk0IDQ1LjkwOEM1OS44NjA3IDQ1LjU2NjcgNjAuMTE2NyA0NS4zIDYwLjQ0NzQgNDUuMTA4QzYwLjc4ODcgNDQuOTE2IDYxLjE3MjcgNDQuODIgNjEuNTk5NCA0NC44MkM2MS42MjA3IDQ0LjgyIDYxLjY0MiA0NC44MiA2MS42NjM0IDQ0LjgyQzYxLjY4NDcgNDQuODIgNjEuNzA2IDQ0LjgyIDYxLjcyNzQgNDQuODJaTTU5LjE5OTQgNTMuMjUyQzYwLjAxIDUzLjI1MiA2MC42Mzk0IDUzLjQzMzMgNjEuMDg3NCA1My43OTZDNjEuNTM1NCA1NC4xNDggNjEuNzU5NCA1NC42Mzg3IDYxLjc1OTQgNTUuMjY4QzYxLjc1OTQgNTUuODIyNyA2MS41ODM0IDU2LjI5NzMgNjEuMjMxNCA1Ni42OTJDNjAuODc5NCA1Ny4wOTczIDYwLjM5OTQgNTcuNDA2NyA1OS43OTE0IDU3LjYyQzU5LjE5NCA1Ny44MzMzIDU4LjUwNiA1Ny45NCA1Ny43Mjc0IDU3Ljk0QzU2LjQxNTQgNTcuOTQgNTUuNDQ0NyA1Ny43MzczIDU0LjgxNTQgNTcuMzMyQzU0LjE4NiA1Ni45MjY3IDUzLjg3MTQgNTYuNDIgNTMuODcxNCA1NS44MTJDNTMuODcxNCA1NS4zODUzIDU0LjAyMDcgNTUuMDEyIDU0LjMxOTQgNTQuNjkyQzU0LjYyODcgNTQuMzcyIDU1LjE0NiA1NC4xOTA3IDU1Ljg3MTQgNTQuMTQ4TDU1Ljc3NTQgNTQuNDA0QzU1LjMyNzQgNTQuMzA4IDU0Ljk2NDcgNTQuMTM3MyA1NC42ODc0IDUzLjg5MkM1NC40MjA3IDUzLjYzNiA1NC4yODc0IDUzLjI3ODcgNTQuMjg3NCA1Mi44MkM1NC4yODc0IDUyLjM2MTMgNTQuNDYzNCA1MS45NzIgNTQuODE1NCA1MS42NTJDNTUuMTY3NCA1MS4zMzIgNTUuNjYzNCA1MS4xNDUzIDU2LjMwMzQgNTEuMDkyTDU3LjE5OTQgNTEuNTI0SDU3LjAwNzRDNTYuNTE2NyA1MS41NjY3IDU2LjE3IDUxLjY3ODcgNTUuOTY3NCA1MS44NkM1NS43NjQ3IDUyLjA0MTMgNTUuNjYzNCA1Mi4yNDQgNTUuNjYzNCA1Mi40NjhDNTUuNjYzNCA1Mi43MzQ3IDU1Ljc1OTQgNTIuOTMyIDU1Ljk1MTQgNTMuMDZDNTYuMTU0IDUzLjE4OCA1Ni40MzY3IDUzLjI1MiA1Ni43OTk0IDUzLjI1Mkg1OS4xOTk0Wk01Ny43Mjc0IDU2LjY2QzU4LjMxNCA1Ni42NiA1OC43OTQgNTYuNjAxMyA1OS4xNjc0IDU2LjQ4NEM1OS41NTE0IDU2LjM3NzMgNTkuODM0IDU2LjIzMzMgNjAuMDE1NCA1Ni4wNTJDNjAuMjA3NCA1NS44ODEzIDYwLjMwMzQgNTUuNjg5MyA2MC4zMDM0IDU1LjQ3NkM2MC4zMDM0IDU1LjIzMDcgNjAuMjAyIDU1LjAzMzMgNTkuOTk5NCA1NC44ODRDNTkuODA3NCA1NC43MzQ3IDU5LjQ1NTQgNTQuNjYgNTguOTQzNCA1NC42Nkg1Ni4zNjc0QzU2LjA2ODcgNTQuNjYgNTUuODE4IDU0LjczNDcgNTUuNjE1NCA1NC44ODRDNTUuNDEyNyA1NS4wNDQgNTUuMzExNCA1NS4yNTczIDU1LjMxMTQgNTUuNTI0QzU1LjMxMTQgNTUuODc2IDU1LjUyNDcgNTYuMTUzMyA1NS45NTE0IDU2LjM1NkM1Ni4zNzggNTYuNTU4NyA1Ni45NyA1Ni42NiA1Ny43Mjc0IDU2LjY2Wk01Ny42NjM0IDQ2LjM0QzU4LjM2NzQgNDYuMzQgNTguOTc1NCA0Ni40NTIgNTkuNDg3NCA0Ni42NzZDNjAuMDEgNDYuOSA2MC40MSA0Ny4yMTQ3IDYwLjY4NzQgNDcuNjJDNjAuOTc1NCA0OC4wMjUzIDYxLjExOTQgNDguNSA2MS4xMTk0IDQ5LjA0NEM2MS4xMTk0IDQ5LjU4OCA2MC45NzU0IDUwLjA2MjcgNjAuNjg3NCA1MC40NjhDNjAuNDEgNTAuODczMyA2MC4wMSA1MS4xODggNTkuNDg3NCA1MS40MTJDNTguOTc1NCA1MS42MzYgNTguMzY3NCA1MS43NDggNTcuNjYzNCA1MS43NDhDNTYuNTU0IDUxLjc0OCA1NS43MDA3IDUxLjUwMjcgNTUuMTAzNCA1MS4wMTJDNTQuNTE2NyA1MC41MTA3IDU0LjIyMzQgNDkuODU0NyA1NC4yMjM0IDQ5LjA0NEM1NC4yMjM0IDQ4LjUgNTQuMzY3NCA0OC4wMjUzIDU0LjY1NTQgNDcuNjJDNTQuOTQzNCA0Ny4yMTQ3IDU1LjM0MzQgNDYuOSA1NS44NTU0IDQ2LjY3NkM1Ni4zNzggNDYuNDUyIDU2Ljk4MDcgNDYuMzQgNTcuNjYzNCA0Ni4zNFpNNTcuNjYzNCA0Ny41NEM1Ny4xNzI3IDQ3LjU0IDU2Ljc2MiA0Ny42Nzg3IDU2LjQzMTQgNDcuOTU2QzU2LjExMTQgNDguMjIyNyA1NS45NTE0IDQ4LjU4NTMgNTUuOTUxNCA0OS4wNDRDNTUuOTUxNCA0OS41MDI3IDU2LjExMTQgNDkuODcwNyA1Ni40MzE0IDUwLjE0OEM1Ni43NjIgNTAuNDI1MyA1Ny4xNzI3IDUwLjU2NCA1Ny42NjM0IDUwLjU2NEM1OC4xNjQ3IDUwLjU2NCA1OC41NzU0IDUwLjQyNTMgNTguODk1NCA1MC4xNDhDNTkuMjI2IDQ5Ljg3MDcgNTkuMzkxNCA0OS41MDI3IDU5LjM5MTQgNDkuMDQ0QzU5LjM5MTQgNDguNTg1MyA1OS4yMjYgNDguMjIyNyA1OC44OTU0IDQ3Ljk1NkM1OC41NzU0IDQ3LjY3ODcgNTguMTY0NyA0Ny41NCA1Ny42NjM0IDQ3LjU0WiIgZmlsbD0id2hpdGUiLz4KPGNpcmNsZSBjeD0iMzIiIGN5PSIxNy41IiByPSIxNiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxwYXRoIGQ9Ik00OCAxNy41QzQ4IDguNjYzNDQgNDAuODM2NiAxLjUgMzIgMS41QzIzLjE2MzQgMS41IDE2IDguNjYzNDQgMTYgMTcuNSIgc3Ryb2tlPSIjMDFBMUREIiBzdHJva2Utd2lkdGg9IjMiLz4KPC9zdmc+Cg==);
    background-repeat: no-repeat;
    background-position: center;
    background-color: rgba(0, 0, 0, 0.3);

}


#panoDiv .pnlm-loading,
#panoDiv .pnlm-lbar,
#panoDiv .pnlm-lmsg,
#panoDiv .pnlm-lbox,
#panoDiv .pnlm-load-box p {
  display: none !important;
}
}
`.trim(),
  placeholderWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none' as const,
    backgroundColor: '#f4f4f4',
    backgroundImage: 'url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2267%22%20height%3D%22100%22%20viewBox%3D%220%200%2067%20100%22%3E%0A%3Cpath%20stroke%3D%22%23ccc%22%20fill%3D%22none%22%20d%3D%22M33.5%2C50%2C0%2C63%2C33.5%2C75%2C67%2C63%2C33.5%2C50m-33.5-50%2C67%2C25m-0.5%2C0%2C0%2C75m-66.5-75%2C67-25m-33.5%2C75%2C0%2C25m0-100%2C0%2C50%22%2F%3E%0A%3C%2Fsvg%3E")',
    backgroundRepeat: 'repeat',
    backgroundPosition: 'center',
    backgroundSize: 'auto',
    opacity: 0.8,
  },

  placeholderCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    background: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    fontFamily: 'Inter, sans-serif',
  },

  placeholderIcon: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    background: '#e6f0ff',
    color: '#1a73e8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: 600,
  },

  placeholderTitle: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#202124',
  },

  placeholderSubtitle: {
    fontSize: '12px',
    color: '#5f6368',
  },
  panoErrorOverlay: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: '12px',
    zIndex: 30,
    pointerEvents: 'none',
  },

  panoErrorPopup: {
    background: '#FFFFFF',
    border: '1px solid #E5E7EB',
    borderRadius: '6px',
    padding: '8px 12px',
    minWidth: '60px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    pointerEvents: 'auto',
    position: 'absolute',
    display: 'flex',
    right: '3%',
  },

  errorHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px',
    fontWeight: 600,
    color: 'black',
  },

  errorIcon: {
    fontSize: '14px',
  },

  errorSubText: {
    fontSize: '12px',
    color: '#475467',
    marginTop: '4px',
  },

  supportLink: {
    color: '#1A73E8',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontWeight: 500,
  },

  ErrorplaceholderIcon: {
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    background: '#FF0000',
    color: '#e6f0ff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '19px',
    fontWeight: 600,
    margin: '2px 5px',
  },
  WarningPlaceholderIcon: {
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    background: '#01A1DD',
    color: '#e6f0ff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '19px',
    fontWeight: 600,
    margin: '2px 5px',
  },

  errorCloseBtn: {
    position: 'absolute',
    top: '0px',
    right: '0px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: '10px',
  },
  adjustpanelopen: {
    position: 'absolute',
    top: 8,
    right: 8,
    color: '#666',
  },
  adjustpointcloudtypo: {
    mb: 2.5,
    fontWeight: 'bold',
    color: '#021E40',
  },
  pointsizeslidetypo: {
    mb: 2.5,
    fontWeight: 500,
    color: '#333',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  pointsizeslidebox: {
    mb: 2,
  },
  pointercolor: {
    '& .esri-slider': {
      width: '100% !important',
    },
    '& .esri-slider__track': {
      backgroundColor: '#e5e5e5 !important',
      height: '8px !important',
      borderRadius: '50px !important',
    },
    '& .esri-slider__segment-0': {
      backgroundColor: '#01A1DD !important',
      borderRadius: '50px !important',
    },
    '& .esri-slider__thumb': {
      backgroundColor: '#ffffff !important',
      border: '2px solid #01A1DD !important',
      width: '20px !important',
      height: '20px !important',
      boxShadow: '0 1px 4px rgba(0,0,0,0.3) !important',
    },
    '& .esri-slider__label': {
      display: 'none !important',
    },
    '& .esri-slider__label-input': {
      display: 'none !important',
    },
    '& .esri-slider__range-labels': {
      display: 'none !important',
    },
    '& .esri-slider__min': {
      display: 'none !important',
    },
    '& .esri-slider__max': {
      display: 'none !important',
    },
  },
  maxValueLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#333',
  },
  sidebarsvg: {
    fontSize: 'inherit',
  },
  OverlaylasView: (size: any, position: any) => ({
    position: 'absolute',
    top: '0px',
    left: '0px',
    width: size.width === 0
      ? 0
      : '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: 9999,
    overflow: 'hidden',
  }),
  mapViewToggleButton: (isSidebarVisible: boolean) => ({
    position: 'absolute',
    top: 16,
    left: 16,
    zIndex: 1000,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '50%',
    padding: '6px',
    width: '36px',
    height: '36px',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
    display: isSidebarVisible ? 'none' : 'block',
    '&:focus': {
      outline: 'none',
      boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
    },
    '&.Mui-focusVisible': {
      outline: 'none',
      boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
    },
    '&:hover': {
      backgroundColor: '#ffffff',
      boxShadow: '0 4px 10px rgba(0,0,0,0.25)',
    },
  }),
  classifiedclickaway: {
    top: '70%',
    left: '50px',
  },
  unclassifiedclickaway: {
    top: '90%',
    left: '50px',
  },
  output3d: {
    top: '45%',
    left: '50px',
  },
});

export default styles;
